exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LayoutHeader_left_2BQy5{display:none}.LayoutHeader_inner_1xR1d{margin:0 auto}.LayoutContent_left_25JVi,.LayoutFooter_right_2_Woz,.LayoutHeader_locale_sZYFc{display:none}.LayoutContent_mainBox_3tRw-{margin:0 auto}.IconInfo_iconInfo_1IFrK{display:none}", ""]);

// exports
